<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idForm" name="nomForm">

        <div class="grid form-group">

          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <label>* {{'PAQUETESEGUROS.LBL_PRODUCTO_SEGURO' | translate}}:</label>

              <p-dropdown disableTab  id="idSeguro" name="nomSeguro" [options]="lisSeguros"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                           formControlName="idSeguro"
                          (onChange)="cambioPLan()"
              ></p-dropdown>
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && f.idSeguro.invalid">
                {{ 'PAQUETESEGUROS.LBL_PRODUCTO_SEGURO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>

          <div class="col-12 md:col-4 lg:col-4" *ngIf="indicadorPlan">
            <div class="div-form">
              <label>* {{'PAQUETESEGUROS.LBL_PLAN' | translate}}:</label>
              <p-dropdown disableTab  id="idSeguroPlan" name="nomSeguroPlan" [options]="lisPlanes"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                           formControlName="idSeguroPlan"
              ></p-dropdown>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && indicadorPlan &&
              f.idSeguroPlan.invalid">
                {{ 'PAQUETESEGUROS.LBL_PLAN' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>

          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form div-form--aling">
              <div class="pt-4">
                <p-checkbox formControlName="indicadorSimuladorCredito" binary="true"></p-checkbox>
                <label class="pl-2">{{'PAQUETESEGUROS.LBL_SIMULADORCREDITO' | translate}}</label>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.indicadorSimuladorCredito.invalid">
                  {{ 'PAQUETESEGUROS.LBL_SIMULADORCREDITO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="grid form-footer-buttons">
          <div class="form-group col-12">

            <div *ngIf="!guardando">
              <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit"
                      pButton></button>
            </div>

            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>





      </form>
    </div>
  </div>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="carTabla" #dt
               [value]="paqSegurosSeguros" selectionMode="single" dataKey="idPaqueteSeguroSeguros"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td class="table-break">{{row.nombreSeguro}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorSimuladorCredito" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="table-break">{{row.planSeguro}}</td>
            <td class="table-break">{{ row.valorPlan ? (row.valorPlan |dinero:2 ): '' }}</td>
            <td class="table-break">{{ row.valorTasa }}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-danger btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_DESHABILITAR' | translate}}" pButton
                        (click)="disable(row)" ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</div>
<p-confirmDialog #cd key="paquetesSegurosSeguros">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

